/**
 * Setzt den Fokus nach einem Absendeversuch ins erste fehlerhafte Feld in
 * Lesereihenfolge, damit Tastatur- und Screenreader-Nutzer dort weitermachen,
 * statt auf dem Button stehen zu bleiben (#820, #1209). Erst nach dem Rendern
 * aufrufen, sonst fehlen die Fehlerklassen noch.
 */
export function focusFirstInvalidField(root: HTMLElement): void {
  root.querySelector<HTMLElement>(INVALID_FIELD)?.focus();
}

// Reactive Forms setzen ng-invalid. Signal Forms tun das nicht, und matInput lässt
// aria-invalid bei leeren Pflichtfeldern weg — dort trägt nur das mat-form-field
// den Fehlerzustand.
const INVALID_FIELD = [
  'input.ng-invalid',
  'textarea.ng-invalid',
  'mat-select.ng-invalid',
  '[aria-invalid="true"]',
  '.mat-form-field-invalid input',
  '.mat-form-field-invalid textarea',
  '.mat-form-field-invalid mat-select',
].join(', ');
